import _ from 'lodash';
import * as api from '~/api';

export default {
    layout: 'widget',
    head: {
        script: [
            {
                src:
                    'https://cdn.jsdelivr.net/npm/iframe-resizer@4.3.2/js/iframeResizer.contentWindow.min.js',
                type: 'text/javascript',
                defer: true,
                body: true
            }
        ],
        __dangerouslyDisableSanitizers: ['script']
    },
    async asyncData({ params, app }) {
        // Retrieve profile data
        const response = await api.perform(
            api.profileQuery(params.slug, 'MAIN', app.i18n.locale),
            process.env.PROFILE_API_MASTER_TOKEN
        );

        // Put featured references first
        let sorted = response.data.data.profile.references;
        const featured = sorted.filter(e => e.state === 'featured');
        if (featured && featured.length) {
            const regular = _.difference(sorted, featured);
            sorted = _.concat(featured, regular);
        }
        response.data.data.profile.references = sorted;

        return response.data.data;
    },
    computed: {
        primaryColor() {
            return this.$store.state.primaryColor;
        },
        cta() {
            return {
                active:
                    this.$route.query.ctatitle && this.$route.query.ctalink
                        ? true
                        : false,
                url: this.$route.query.ctalink,
                title: this.$route.query.ctatitle,
                color:
                    (this.$route.query.ctacolor &&
                        '#' + this.$route.query.ctacolor) ||
                    this.primaryColor,
                style: this.$route.query.ctastyle || 'default',
                position: this.$route.query.ctaposition || 'bottom'
            };
        },
        widgetLink() {
            return this.$i18n.locale === this.$i18n.defaultLocale
                ? `https://trustfolio.co/profil/${
                      this.profile.url
                  }?ref=widgetBadge`
                : `https://trustfolio.co/profil/${this.$i18n.locale}/${
                      this.profile.url
                  }?ref=widgetBadge`;
        }
    },
    beforeMount() {
        const primaryColor =
            (this.$route.query.color && '#' + this.$route.query.color) ||
            this.profile.color;
        this.$store.commit('setPrimaryColor', primaryColor);
    }
};
